import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		userObject: {
			userName: 'Austin Hicks',
			userEmail: 'austin@fadesk.com',
			userNotifications: [
			{
				module: 'Calls',
				notification: 'Call Charles Cooper at 9:30 am'
			},
			{
				module: 'Calls',
				notification: 'Call Kevin Harris at 6:00 pm'
			},
			{
				module: 'Meetings',
				notification: 'Meeting with Rachel Wood at 1:00 pm'
			},
			{
				module: 'Tasks',
				notification: '7 new tasks have been assigned to you'
			},
			{
				module: 'Tasks',
				notification: '10 tasks are overdue'
			},
			{
				module: 'Sales Targets',
				notification: 'Achieved target of 28 Oct 18 to 27 Nov 18'
			},
			{
				module: 'Notices',
				notification: 'Board meeting after lunch'
			},
			{
				module: 'Notices',
				notification: 'Christmas celebration committee meeting'
			}
			],
			userModules: [
			{
				moduleName: 'Leads',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Leads"
				},
				{
					pageIcon: "View",
					pageName: "View Leads"
				}
				]
			},
			{
				moduleName: 'Customers',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Customers"
				},
				{
					pageIcon: "View",
					pageName: "View Customers"
				}
				]
			},
			{
				moduleName: 'Inventory',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Products"
				},
				{
					pageIcon: "View",
					pageName: "View Products"
				},
				{
					pageIcon: "Add",
					pageName: "Add Services"
				},
				{
					pageIcon: "View",
					pageName: "View Services"
				}
				]
			},
			{
				moduleName: 'Quotations',
				modulePages: [
				{
					pageIcon: "Create",
					pageName: "Create Quotations"
				},
				{
					pageIcon: "View",
					pageName: "View Quotations"
				}
				]
			},
			{
				moduleName: 'Orders',
				modulePages: [
				{
					pageIcon: "Create",
					pageName: "Create Orders"
				},
				{
					pageIcon: "View",
					pageName: "View Orders"
				}
				]
			},
			{
				moduleName: 'Billing',
				modulePages: [
				{
					pageIcon: "Create",
					pageName: "Create Bills"
				},
				{
					pageIcon: "View",
					pageName: "View Bills"
				}
				]
			},
			{
				moduleName: 'Payments',
				menuLink: true
			},
			{
				moduleName: 'Calls',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Calls"
				},
				{
					pageIcon: "View",
					pageName: "View Calls"
				}
				]
			},
			{
				moduleName: 'Meetings',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Meetings"
				},
				{
					pageIcon: "View",
					pageName: "View Meetings"
				}
				]
			},
			{
				moduleName: 'SMS',
				modulePages: [
				{
					pageIcon: "Send",
					pageName: "Send SMS"
				},
				{
					pageIcon: "View",
					pageName: "View SMS"
				}
				]
			},
			{
				moduleName: 'Emails',
				modulePages: [
				{
					pageIcon: "Send",
					pageName: "Send Emails"
				},
				{
					pageIcon: "View",
					pageName: "View Emails"
				}
				]
			},
			{
				moduleName: 'Tasks',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Tasks"
				},
				{
					pageIcon: "View",
					pageName: "View Tasks"
				}
				]
			},
			{
				moduleName: 'Sales Targets',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Company Targets"
				},
				{
					pageIcon: "View",
					pageName: "View Company Targets"
				},
				{
					pageIcon: "Add",
					pageName: "Add Sales Person Targets"
				},
				{
					pageIcon: "View",
					pageName: "View Sales Person Targets"
				}
				]
			},
			{
				moduleName: 'Incentives',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Incentives"
				},
				{
					pageIcon: "View",
					pageName: "View Incentives"
				}
				]
			},
			{
				moduleName: 'Vendors',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Vendors"
				},
				{
					pageIcon: "View",
					pageName: "View Vendors"
				}
				]
			},
			{
				moduleName: 'Contacts',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Contacts"
				},
				{
					pageIcon: "View",
					pageName: "View Contacts"
				}
				]
			},
			{
				moduleName: 'Notices',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Notices"
				},
				{
					pageIcon: "View",
					pageName: "View Notices"
				}
				]
			},
			{
				moduleName: 'Income',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Income"
				},
				{
					pageIcon: "View",
					pageName: "View Income"
				}
				]
			},
			{
				moduleName: 'Expenditure',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Expenditure"
				},
				{
					pageIcon: "View",
					pageName: "View Expenditure"
				}
				]
			},
			{
				moduleName: 'Users',
				modulePages: [
				{
					pageIcon: "Add",
					pageName: "Add Users"
				},
				{
					pageIcon: "View",
					pageName: "View Users"
				},
				{
					pageIcon: "View",
					pageName: "Access Roles"
				}
				]
			},
			{
				moduleName: 'Reports',
				modulePages: [
				{
					pageIcon: "Reports",
					pageName: "Lead Reports"
				},
				{
					pageIcon: "Reports",
					pageName: "Call Reports"
				},
				{
					pageIcon: "Reports",
					pageName: "Meeting Reports"
				}
				]
			},
			{
				moduleName: 'Settings',
				menuLink: true
			}
			]
		}
	},
	mutations: {

	},
	actions: {

	}
})
